<template>
  <div class='out-wrap'>
    <h3>工作&教育信息</h3>
    <van-form ref='eduationForm'>
      <van-form v-for='(workItem, workIndex) in workInfo' :key='workIndex'>
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="workItem.start_work_time"
            label="开始时间"
            placeholder="请选择开始时间"
            @click="startWorkTimeClick(workIndex)"
          />
          <van-popup v-model="startWorkTimeShowPicker" position="bottom">
            <van-datetime-picker
              :min-date="minDate"
              v-model="currentDate"
              type="year-month"
              @confirm="startWorkTimeConfirm"
              @cancel="startWorkTimeShowPicker = false"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="workItem.end_work_time"
            label="结束时间"
            placeholder="请选择结束时间"
            @click="endWorkTimeClick(workIndex)"
          />
          <van-popup v-model="endWorkTimeShowPicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              :min-date="minDate"
              type="year-month"
              @confirm="endWorkTimeConfirm"
              @cancel="endWorkTimeShowPicker = false"
            />
          </van-popup>
          <van-field
            @click='itemClick(workIndex)'
            v-model="workItem.work_address"
            clearable
            name="工作单位"
            label="工作单位"
            placeholder="请输入工作单位名称"
          />
          <van-field
            @click='itemClick(workIndex)'
            v-model="workItem.work_role"
            clearable
            name="任职岗位"
            label="任职岗位"
            placeholder="请输入岗位名称"
          />
          <van-field
          readonly
          clickable
          name="picker"
          :value="workItem.work_month_pay"
          label="月薪"
          placeholder="请选择月薪薪资"
          @click="salaryTypePicker = true"
        />
        <van-popup v-model="salaryTypePicker" position="bottom">
          <van-picker show-toolbar
            @confirm="salaryTypeConfirm"
            @cancel="salaryTypePicker = false"
            :columns="salary" />
        </van-popup>
          <van-field
          readonly
          clickable
          name="picker"
          :value="workItem.work_year_pay"
          label="年薪"
          placeholder="请选择年薪薪资"
          @click="yearSalaryTypePicker = true"
        />
        <van-popup v-model="yearSalaryTypePicker" position="bottom">
          <van-picker show-toolbar
            @confirm="yearSalaryTypeConfirm"
            @cancel="yearSalaryTypePicker = false"
            :columns="yearSalary" />
        </van-popup>
          <van-field
            @click='itemClick(workIndex)'
            v-model="workItem.work_referener"
            clearable
            name="证明人"
            label="证明人"
            placeholder="请输入姓名"
          />
          <van-field
            @click='itemClick(workIndex)'
            v-model="workItem.work_relationship"
            clearable
            name="关系"
            label="关系"
            placeholder="请输入关系"
          />
          <van-field
            v-model="workItem.work_referener_phone"
            clearable
            maxlength="11"
            type='tel'
            name="手机号"
            label="手机号码"
            :rules="[{ required: false, message: '请填写手机号码' },{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误'}]"
            placeholder="请输入手机号码"
          />
          <div v-if='workInfo.length == 1 && workIndex == 0 '  style='margin:16px;'></div>
          <div v-else class="del-btn">
            <van-button color='#f8bb5b'  icon="delete-o" size='small'  @click="deleteInfo('work',workIndex)">删除</van-button>
          </div>
        </van-form>
        <div class='add-button'>
          <van-button plain block  icon="plus" v-if='workInfo.length < 4 '  @click="addWorkInfo">添加工作经历</van-button>
        </div>
        <van-form v-for='(studyItem, index) in studyExp' :key='"study"+index' ref='educationForm'>
            <van-field
            required
            readonly
            clickable
            name="学历"
            :value="studyItem.level"
            label="学历"
            placeholder="请选择学历"
            @click="levelClick(index)"
            :rules="[{ required: true, message: '请选择学历' }]"
          />
          <van-popup v-model="edutionPicker"  position="bottom">
            <van-picker
              show-toolbar
              :columns="educationSelect"
              @confirm="levelConfirm"
              @cancel="edutionPicker = false"
            />
          </van-popup>
          <van-field
          required
            @click='studyClick(index)'
            v-model="studyItem.school_name"
            clearable
            name="毕业院校"
            label="毕业院校"
            placeholder="请输入院校"
            :rules="[{ required: true, message: '请输入院校' }]"
          />
          <van-field
          required
            @click='studyClick(index)'
            v-model="studyItem.major"
            clearable
            name="所学专业"
            label="所学专业"
            placeholder="请输入专业"
            :rules="[{ required: true, message: '请输入专业' }]"
          />
          <van-field
          required
            readonly
            clickable
            name="datetimePicker"
            :value="studyItem.graduation_time"
            label="毕业时间"
            placeholder="点击选择毕业时间"
            :rules="[{ required: true, message: '请选择毕业时间' }]"
            @click="graduationClick(index)"
          />
          <van-popup v-model="graduationTimeShowPicker" position="bottom">
            <van-datetime-picker
              :min-date="minDate"
              type="date"
              v-model="currentDate"
              @confirm="graduationConfirm"
              @cancel="graduationTimeShowPicker = false"
            />
          </van-popup>
          <van-field required name="radio" label="是否统招" @click='studyClick(index)'>
            <template #input>
              <van-radio-group  v-model="studyItem.isAllday" checked-color='#edad57' direction="horizontal" >
                <van-radio name="1">是</van-radio>
                <van-radio name="2">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div v-if='studyExp.length <= 1 && index === 0' style='margin:16px'></div>
          <div v-else class="del-btn">
            <van-button color='#f8bb5b'  icon="delete-o" size='small'   @click="deleteInfo('study',index)">删除</van-button>
          </div>
          </van-form>
          <div  class='add-button'>
            <van-button plain block icon="plus"  v-if='studyExp.length < 2 ' @click="addStudyInfo">添加学习经历</van-button>
          </div>
        <van-field colon v-model.trim="education_info.skills_sertificate" rows="4" autosize  type='textarea' clearable label="技能证书" placeholder="请输入您取得的技能证书"/>
      <div style="margin: 16px;">
        <van-button class='submit-btn' block type="info" @click="nextStep">下一步</van-button>
      </div>
     </van-form>
  </div>
</template>

<script>
import { getStore, setStore } from '../../../utils/localStore';
import { getNumArray } from "../../../utils/tool"
import moment from 'moment'
import _ from 'lodash'
export default {
  data() {
    return {
      education_info: {
        skills_sertificate: ''
      },
      workInfo: [ //工作信息
          {
            start_work_time:'',
            end_work_time:'',
            work_address:'',
            work_role:'',
            work_month_pay:'',
            work_year_pay:'',
            work_referener:'',
            work_relationship:'',
            work_referener_phone:''
          }
        ],
        educationSelect:['培训学校','初中及以下','高中','中专/中技','大专','本科', '硕士', 'MBA/EMBA', '博士'],
      studyExp: [
          {
            level:'',
            school_name:'',
            major:'',
            graduation_time:'',
            isAllday:'1',
          }
        ],
      edutionPicker: false,
      startWorkTimeShowPicker: false,
      endWorkTimeShowPicker: false,
      minDate: new Date(1980, 0, 1),
      currentDate: new Date(),
      salaryTypePicker: false,
      certificate_timePicker: false,
      salary: [
          {
            values: [],
            defaultIndex: 1,
          }
        ],
      yearSalaryTypePicker: false,
        yearSalary: [
          {
            values: [],
            defaultIndex: 1,
          }
        ],
      graduationTimeShowPicker: false,
      currentIndex: 0,
      currentWorkIndex: 0
    }
  },
  mounted() {
    let tmpNum = []
      _.map(getNumArray(1, 40), item => {
        tmpNum.push(item+"K")
      })
    this.salary[0].values  =  _.cloneDeep(tmpNum);
    let yearNum = []
      _.map(getNumArray(1, 50), item => {
        yearNum.push(item+"W")
      })
      this.yearSalary[0].values = _.cloneDeep(yearNum);
    this.$nextTick(() => {
      let data = getStore({name: 'applyInfo'});
      if(data) {
        this.educationInit(data)
      }
      let haveFillData = getStore({name: 'educationPageInfo'})
      if(haveFillData){
        this.education_info = haveFillData;
        this.workInfo = haveFillData.work;
        this.studyExp = haveFillData.study;
      }
    })
    
  },
  beforeRouteLeave(to, from, next){
      setStore({
          name: 'educationPageInfo',
          content: Object.assign({}, this.education_info, {work: this.workInfo}, {study: this.studyExp}),
          options: {
            expiry: '2h'
          }
      })
      next()
  },
  methods: {
    educationInit(data) {
      //筛选学历、培训证书
      let trainInfo = JSON.parse(data.train),
          educationInfo = JSON.parse(data.studyExp),
          workInfo = JSON.parse(data.workInfo);
          this.workInfo = workInfo;
          this.studyExp = educationInfo;
      _.map(trainInfo, item => {
        if(item.train_certificate && item.train_certificate != ''){
          this.education_info.skills_sertificate += item.train_certificate+'；'
        }
      })
    },
    pickerConfirm(val,type,spec='') { //统一方法替换
      if(spec){
        let str = ''
        _.map(val, item => {
          str += item.name+'/'
        })
        this.education_info[type] = str;
      }else{
        this.education_info[type] = !val.v ? moment(val).format('YYYY-MM-DD') : val.v;
      }
      let picker = type+'Picker'
      this[picker] = false;
    },
    levelConfirm(val) {
        this.studyExp[this.currentIndex].level = val;
        this.edutionPicker = false;
      },
    startWorkTimeConfirm(val){
        this.workInfo[this.currentWorkIndex].start_work_time = moment(val).format("YYYY-MM");
        this.startWorkTimeShowPicker = false;
      },
    endWorkTimeConfirm(val){
        this.workInfo[this.currentWorkIndex].end_work_time = moment(val).format("YYYY-MM");
        this.endWorkTimeShowPicker = false;
      },
    salaryTypeConfirm(val){
        this.workInfo[this.currentWorkIndex].work_month_pay = val[0]
        this.salaryTypePicker = false;
      },
    yearSalaryTypeConfirm(val){
        this.workInfo[this.currentWorkIndex].work_year_pay = val[0]
        this.yearSalaryTypePicker = false;
      },
    graduationConfirm(val) {
        this.studyExp[this.currentIndex].graduation_time = moment(val).format("YYYY-MM-DD");
        this.graduationTimeShowPicker = false;
      },
    addStudyInfo() {
        this.studyExp.push({
          level:'',
          school_name:'',
          major:'',
          graduation_time:'',
          isAllday:'1',
        })
        this.currentIndex = this.studyExp.length - 1;
      },
    levelClick(val){
        this.edutionPicker = true;
        this.currentIndex = val;
      },
    studyClick(index){
        this.currentIndex = index;
      },
    graduationClick(val) {
        this.graduationTimeShowPicker = true;
        this.currentIndex = val;
      },
      addWorkInfo(){
        this.workInfo.push({
          start_work_time:'',
          end_work_time:'',
          work_address:'',
          work_role:'',
          work_month_pay:'',
          work_year_pay:'',
          work_referener:'',
          work_relationship:'',
          work_referener_phone:''
        })
        this.currentWorkIndex = this.workInfo.length - 1;
      },
      deleteInfo(type,index){
        if(type == 'study'){
          this.studyExp.splice(index, 1)
        }else{
          this.workInfo.splice(index, 1)
        }
      },
      startWorkTimeClick(val){
        this.startWorkTimeShowPicker = true;
        this.currentWorkIndex = val;
      },
      endWorkTimeClick(val){
        this.endWorkTimeShowPicker = true;
        this.currentWorkIndex = val;
      },
      itemClick(val){
        this.currentWorkIndex = val;
      },
    nextStep() {
      this.$refs.eduationForm.validate().then(res => {
        this.education_info = Object.assign({}, this.education_info, {'work': this.workInfo}, {'study': this.studyExp})
        setStore({
          name: 'educationPageInfo',
          content: this.education_info,
          options: {
            expiry: '2h'
          }
        })
        this.$router.push({
          path:'/induction_value',
          query:{
            id: this.$route.query.id,
            staff_id: this.$route.query.staff_id,
            type: this.$route.query.type,
            page: 'employess'
          }
        })
      }).catch( err => {
        this.$toast({
          message: `请填写${err[0].name}`,
          duration: 2500
        })
        return
      })
    }
  }

}
</script>

<style lang='less' scoped>
@import "../../../assets/css/page.css";
@import "../../../assets/css/wrap.css";
</style>